import { Store } from "vuex";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import { RED } from "@/resources/constants/busyReasons";
import UserHandler from "@/resources/mixins/graphicClient/userHandler";
import { UserReceiveMessageType } from "@/resources/constants/graphicClient/graphicClient";
import { MEETING_TYPE } from "@/resources/constants/meeting";
export default class RoomSocketHandler {
  static secondsLeft: number;
  static seconds: number;
  static count: number;
  static timeout: NodeJS.Timeout | null = null;
  /**
   * ROOM_JOIN_CHAT
   * */
  static async roomJoinChat(store?: Store<any>, data?: any): Promise<void> {
    // do nothing
  }
  /**
   * ROOM_IMAGE_UPDATED
   * */
  static async roomImageUpdated(store?: Store<any>, data?: any): Promise<void> {
    //await store.dispatch("SpaceStore/setSpaceAction", data);
    await store.dispatch("GraphicClientStore/roomUpdateAction", data);
  }
  /**
   * ROOM_WEBINAR_OPENED
   * */
  static async roomWebinarOpened(
    store?: Store<any>,
    data?: any,
    vs?: any
  ): Promise<void> {
    const roomIdWebinar = store.getters["WebinarStore/getRoomId"];
    if (!roomIdWebinar) {
      return;
    }
    await store?.dispatch("MeetingStore/setWebinarActiveAction", true);
    const _userHandler = new UserHandler();
    await _userHandler.handleMessage(
      UserReceiveMessageType.USER_CONNECT_TO_ROOM_CALL,
      data.id,
      store,
      vs,
      true,
    );
  }
  /**
   * ROOM_WEBINAR_CLOSED
   * */
  static async roomWebinarClosed(
    store?: Store<any>,
    data?: any,
    vs?: any
  ): Promise<void> {
    const meetingType = store.getters["MeetingStore/getMeetingType"];
    if (!meetingType || meetingType !== MEETING_TYPE.WEBINAR) {
      return;
    }
    await store?.dispatch("MeetingStore/setWebinarActiveAction", false);
    const _userHandler = new UserHandler();
    await _userHandler.handleMessage(
      UserReceiveMessageType.USER_DISCONNECT_FROM_ROOM_CALL,
      data.id,
      store,
      vs
    );
    //Todo si otra persona tiene abierto el modal de confirmar que se cierra solo.
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (data.id == roomId)
      await store?.dispatch("SystemStore/setShowCloseWebinarModalAction", {
        close: false,
        id: 0,
      });
  }
  /**
   * ROOM_UPDATE
   */
  static async roomUpdate(
    store?: Store<any>,
    data?: RoomInterface
  ): Promise<void> {
    await store.dispatch("GraphicClientStore/roomUpdateAction", data);
    await store.dispatch("SpaceStore/setRoomUpdateAction", data);
  }
  /**
   * ROOM_VIDEO_URL_CHANGED
   * */
  static async roomVideoUrlChanged(
    store?: Store<any>,
    data?: RoomInterface
  ): Promise<void> {
    const room = store.getters["SpaceStore/getSpace"].scenario.rooms.filter(
      (room: { id: number; }) => room.id === data.id
    )[0];
    room.videoUrl = data.videoUrl;
    const roomId = store.getters["MeetingStore/getRoomId"];
    if (data.id == roomId)
      await store.dispatch("MeetingStore/setVideoUrlAction", data.videoUrl);
  }
  /**
   * Private Event
   * ROOM_JOIN_MEETING
   * */
  static async roomJoinMeeting(store?: Store<any>, data?: any): Promise<void> {
    const space = store.getters["SpaceStore/getSpace"];
    if (data.room.scenario.space.id != space.id) {
      return;
    }
    const userLocal = store.getters["UserStore/getSpaceUser"];
    if (userLocal.superSpaceUser.user.availableStatus !== "RED" && userLocal.superSpaceUser.user.emoji !== "U+1F4DE") {
      const pre_status = {
        availableStatus: userLocal.superSpaceUser.user.availableStatus,
        availableStatusReason:
          userLocal.superSpaceUser.user.availableStatusReason,
        emoji: userLocal.superSpaceUser.user.emoji,
      };
      localStorage.setItem("pre_status", JSON.stringify(pre_status));
    }

    await store.dispatch("UserStore/updateUserStatusAction", {
      userId: userLocal.superSpaceUser.user.id,
      props: {
        availableStatus: RED.type,
        availableStatusReason: null,
        emoji: "U+1F4DE",
      },
      callback: (user: any) => {
        store.dispatch("SpaceStore/updateUserInSpace", user);
      },
    });
    await store.dispatch("MeetingStore/setMeetingDataAction", data);
    await store.dispatch("SidebarStore/setOpenCall", true);
    await store.dispatch(
      "ChatStore/setMinimizeChatAction",
      !store.getters["UserStore/getConfig"].chat.openRoomChatByDefault
    );
    await store.dispatch("GraphicClientStore/resizeGraphicClientAction");
  }
  /**
  * POLL_CREATED
  * */
  static async pollCreated(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch("PollStore/setPollAction", null);
    setTimeout(async () => {
      await store.dispatch("PollStore/setPollAction", data.data);
      this.calculateTime(store, data.data);
    }, 100);
  }
  /**
  * POLL_UPDATE
* */
  static async pollUpdate(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch("PollStore/setPollAction", data.data);
    this.calculateTime(store, data.data);
  }
  /**
  * POLL_VOTED
  * */
  static async pollVoted(store?: Store<any>, data?: any): Promise<void> {
    await store.dispatch("PollStore/setPollAction", data.data);
    this.calculateTime(store, data.data);
  }
  /**
  * POLL_CLOSED
  * */
  static async pollClosed(store?: Store<any>, data?: any): Promise<void> {
    clearInterval(this.timeout);
    await store.dispatch("PollStore/setPollAction", null);
  }

  static async calculateTime(store?: Store<any>, data?: any) {
    clearInterval(this.timeout);
    this.seconds = data.duration * 60;
    let arrayTimeleft = data.timeLeft.split(":");
    this.secondsLeft = (parseInt(arrayTimeleft[0]) * 60) + parseInt(arrayTimeleft[1]);
    if (this.secondsLeft == 0) {
      await store.dispatch("PollStore/setPollTimeAction", 100);
      return;
    }
    this.count = this.seconds - this.secondsLeft;
    let result = this.count * (100 / this.seconds);
    await store.dispatch("PollStore/setPollTimeAction", result);
    this.countdown(store);
  }

  static async countdown(store?: Store<any>) {
    this.timeout = setTimeout(async () => {
      this.count++;
      let result = this.count * (100 / this.seconds);
      await store.dispatch("PollStore/setPollTimeAction", result);
      if (this.count >= this.seconds)
        return;
      this.countdown(store);
    }, 1000);
  }
}
